<template>
  <div>
    <mobile v-if="deviceWidth<640"></mobile>
    <pc v-else></pc>
  </div>
</template>

<script>
import mobile from "./mobile.vue";
import pc from "./pc.vue";
export default {
  components: { mobile, pc },
  data() {
    return {
      deviceWidth: "0",
    };
  },
  created() {
    this.getDevice();
    window.addEventListener("resize", this.getDevice);
  },
  destroyed() {
    window.removeEventListener("resize", this.getDevice);
  },
  methods: {
    // 获取浏览器宽高
    getDevice() {
      this.deviceWidth = window.innerWidth;
    },
  },
};
</script>

<style></style>
